interface SkeletonProps {
  className?: string;
}

export function SkeletonBlock({ className = "" }: SkeletonProps) {
  return <div className={`skeleton-shimmer rounded-md ${className}`} aria-hidden="true" />;
}

export function TableSkeleton({ rows = 5, columns = 6 }: { rows?: number; columns?: number }) {
  return (
    <div className="w-full" aria-busy="true">
      <div className="overflow-hidden rounded-[10px] border border-line bg-card">
        <div className="border-b border-line bg-page px-4 py-3.5">
          <SkeletonBlock className="h-3 w-40" />
        </div>
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4 border-b border-line px-4 py-4 last:border-0">
            <SkeletonBlock className="h-4 w-4 shrink-0" />
            {Array.from({ length: columns }).map((_, c) => (
              <SkeletonBlock key={c} className={`h-4 shrink-0 ${c % 2 === 0 ? "flex-1" : "w-16"}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function CardSkeleton({ cards = 4 }: { cards?: number }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" aria-busy="true">
      {Array.from({ length: cards }).map((_, i) => (
        <div key={i} className="rounded-[10px] border border-line bg-card p-5 shadow-card">
          <SkeletonBlock className="h-3 w-28" />
          <SkeletonBlock className="mt-3 h-7 w-20" />
          <SkeletonBlock className="mt-4 h-3 w-32" />
        </div>
      ))}
    </div>
  );
}